import { FunctionComponent } from 'react';
import cn from 'classnames';
import { trackFeature } from '@/utils/adobeLaunch';
import { getFaqUrl } from '@/utils/faq';
import { t } from '@/utils/i18n';
import { isEmbroideryMode } from '@/utils/params';
import './PriceInfo.scss';

interface Props {
  className?: string;
  showVatIncludedString: boolean;
  printPriceTranslationKey: string;
  shippingCostsTranslationKey?: string;
}

export const PriceInfo: FunctionComponent<Props> = ({
  className,
  showVatIncludedString,
  printPriceTranslationKey,
  shippingCostsTranslationKey = 'basket.shippingCosts',
}) => {
  const vatString = showVatIncludedString ? t('basket.vatIncluded') : t('basket.vatExcluded');
  const classes = cn('price-info', className);
  return (
    <div className={classes}>
      {vatString}
      &nbsp;
      {printPriceTranslationKey && (
        <>
          {isEmbroideryMode() ? (
            <span>{t(printPriceTranslationKey)}</span>
          ) : (
            <a
              href={getFaqUrl('printingCost')}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => trackFeature('printing-faq')}
            >
              {t(printPriceTranslationKey)}
            </a>
          )}
          ,&nbsp;
        </>
      )}
      {isEmbroideryMode() ? (
        <span>{t(shippingCostsTranslationKey)}</span>
      ) : (
        <a
          href={getFaqUrl('shipping')}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => trackFeature('delivery-faq')}
        >
          {t(shippingCostsTranslationKey)}
        </a>
      )}
    </div>
  );
};
